import * as React from 'react';
import type { Justifications as Justification } from 'contracts/Justifications';
import { api, applyQueryString } from 'services/api';
import { usePermission } from 'hooks/usePermission';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';
import { useQuery } from 'react-query';

export const useInvoiceJustificationOptions = () => {
  const { hasPermissionTo } = usePermission();

  const justificationsType = React.useMemo((): 1 | 2 | undefined => {
    if (hasPermissionTo(['JUSTIFICATIONS.FINDALLINVOICEJUSTIFICATIONS'])) {
      return undefined;
    } else if (hasPermissionTo(['JUSTIFICATIONS.FINDTRACKINGJUSTIFICATIONS'])) {
      return 1;
    } else if (hasPermissionTo(['JUSTIFICATIONS.FINDWAREHOUSEJUSTIFICATIONS'])) {
      return 2;
    }
  }, [hasPermissionTo]);

  const fetchOptions = React.useCallback(async () => {
    const url = applyQueryString('/justifications', {
      asList: true,
      ...(justificationsType !== undefined && { type: justificationsType }),
    });

    const { data } = await api.get<Justification[]>(url);
    return data.map((justification) => ({
      value: justification.id,
      label: justification.description,
    }));
  }, [justificationsType]);

  const optionsQuery = useQuery({
    queryKey: ['fetch-justification-options'],
    queryFn: fetchOptions,
    initialData: [],
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: optionsQuery.data?.map(optionsMapper) || [],
    multiSelectOptions: optionsQuery.data?.map(multiSelectorOptionsMapper) || [],
    loading: optionsQuery.isLoading,
  };
};